import { useAuth } from '@/features/auth/hooks/useAuth'
import { UserRole } from '@/types/entities'
import { ArtworkListPage } from '@/features/artworks/pages/ArtworkListPage'
import { ArtworkSearchPage } from './ArtworkSearchPage'

/**
 * Wrapper component that shows different artworks pages based on user role:
 * - Managers see the admin search/browse view with all artworks
 * - Artists see their own artworks list
 */
export function ArtworksPage() {
  const { user } = useAuth()

  if (user?.role === UserRole.MANAGER) {
    return <ArtworkSearchPage />
  }

  return <ArtworkListPage />
}
